module.exports = __webpack_public_path__ + "img/JNY-Copay-Card.6c6d3eb4.png";